import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function HackDetails() {
  const { id } = useParams();
  const [hack, setHack] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHack = async () => {
      try {
        const response = await fetch(`/api/get-submission-details?id=${id}`);
        const result = await response.json();
        
        if (result.success) {
          setHack(result.submission);
        } else {
          setError(result.error || 'Hack not found');
        }
      } catch (err) {
        setError('Failed to load hack details');
        console.error('Error fetching hack:', err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchHack();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="hack-details-page">
        <div className="container">
          <div className="loading-state">
            <p>Loading hack details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !hack) {
    return (
      <div className="hack-details-page">
        <div className="container">
          <div className="error-state">
            <h1>Hack Not Found</h1>
            <p>{error || 'The requested hack could not be found.'}</p>
            <a href="/hacks" className="cta-button">Back to Hacks</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="hack-details-page">
      <div className="container">
        <div className="details-header">
          <h1>{hack.projectName}</h1>
          <div className="hack-meta">
            <span className="amount">{hack.amount}</span>
            <span className="date">{hack.month} {hack.year}</span>
          </div>
        </div>

        <div className="details-content">
          <div className="description-section">
            <h2>Overview</h2>
            <p>{hack.description}</p>
          </div>

          {hack.markdownContent && (
            <div className="markdown-section">
              <h2>Full Report</h2>
              <div className="markdown-content">
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm]}
                  components={{
                    img: ({ src, alt }) => (
                      <img 
                        src={src} 
                        alt={alt} 
                        style={{ 
                          maxWidth: '100%', 
                          height: 'auto',
                          borderRadius: '8px',
                          margin: '1rem 0'
                        }} 
                      />
                    )
                  }}
                >
                  {hack.markdownContent}
                </ReactMarkdown>
              </div>
            </div>
          )}

          {hack.images && hack.images.length > 0 && (
            <div className="images-section">
              <h2>Evidence Images</h2>
              <div className="images-grid">
                {hack.images.map((image, index) => (
                  <div key={index} className="image-item">
                    <img 
                      src={image.url} 
                      alt={image.name}
                      onClick={() => window.open(image.url, '_blank')}
                    />
                    <p>{image.name}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="back-section">
            <a href="/hacks" className="cta-button secondary">← Back to Hacks</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HackDetails;
